import { createFileRoute } from "@tanstack/react-router";
import AdminGiftCardDetailPage from "@/admin/pages/gift-card-detail";
import { isGiftStatus, type GiftStatus } from "@/admin/pages/gift-cards";

/**
 * The `l*` keys are the ledger search this gift was opened from, for the header's
 * Previous / Next. `lstatus` is always sent ("all" = unfiltered), so its presence is
 * what tells the header it has a list to walk.
 */
export type AdminGiftCardDetailSearch = {
  lq?: string;
  lstatus?: GiftStatus | "all";
};

export const Route = createFileRoute("/admin/gift-cards/$giftCardId")({
  component: AdminGiftCardDetailPage,
  validateSearch: (search: Record<string, unknown>): AdminGiftCardDetailSearch => ({
    lq: typeof search.lq === "string" && search.lq ? search.lq : undefined,
    lstatus:
      search.lstatus === "all" ? "all" : isGiftStatus(search.lstatus) ? search.lstatus : undefined,
  }),
});
